import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import * as Highcharts from "highcharts";
import { HighchartsChartComponent } from "highcharts-angular";
import { FormsModule } from "@angular/forms";

import { HC_COLORS } from "../highcharts-shared";

@Component({
  selector: "app-portfolio-return-bar-chart",
  templateUrl: "./portfolio-return-bar-chart.component.html",
  styleUrls: ["./portfolio-return-bar-chart.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [HighchartsChartComponent, FormsModule],
})
export class PortfolioReturnBarChartComponent implements OnInit {
  @Input() rawData: any;
  @Input() title: any = "";
  @Input() subHeader: any = {};
  @Input() isPortfolioPerformance: boolean = false;

  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor = "chart";
  chartOptions: Highcharts.Options = {};
  chartType: string = "volatility";
  series: any[] = [];
  name: string = "";
  index: any = [];

  ngOnInit(): void {
    if (this.isPortfolioPerformance) {
      this.rawData[0].data.sort((a, b) => {
        return b.value - a.value;
      });

      this.rawData[1].data.sort((a, b) => {
        return b.value - a.value;
      });
    }
    this.setRiskData();
  }

  ngOnChanges(): void {
    this.changeData();
  }

  changeData() {
    if (this.chartType === "return") {
      this.setReturnData();
    } else {
      this.setRiskData();
    }
  }

  private setRiskData() {
    if (this.isPortfolioPerformance) {
      this.series = [
        {
          type: "bar",
          name: "Volatility",
          data: this.rawData[1].data.map((item) => item.value),
        },
      ];
      this.index = this.rawData[1];
    } else {
      this.rawData[0].data.sort((a, b) => {
        return b.risk - a.risk;
      });
      this.series = [
        {
          type: "bar",
          name: "Risk",
          data: this.rawData[0].data.map((item) => item.risk),
        },
      ];
      this.chartType = "risk";
      this.index = this.rawData[0];
    }
    this.initChart();
  }

  private setReturnData() {
    if (this.isPortfolioPerformance) {
      this.series = [
        {
          type: "bar",
          name: "Return",
          data: this.rawData[0].data.map((item) => item.value),
        },
      ];
      this.index = this.rawData[0];
    } else {
      this.rawData[0].data.sort((a, b) => {
        return b.return - a.return;
      });
      this.series = [
        {
          type: "bar",
          name: "Return",
          data: this.rawData[0].data.map((item) => item.return),
        },
      ];
      this.index = this.rawData[0];
    }
    this.initChart();
  }

  initChart() {
    // if (this.isPortfolioPerformance) {
    //   this.index = this.rawData[0];
    //   if(this.chartType == 'risk')
    //     this.index = this.rawData[1];
    // }else{
    //   this.index = this.rawData[0]
    // }

    this.chartOptions = {
      chart: {
        height: 380,
        type: "bar",
        backgroundColor: "transparent",
        spacing: [12, 4, 8, 4],
        style: { fontFamily: "Inter, system-ui, sans-serif" },
      },
      credits: { enabled: false },
      title: { text: "" },
      tooltip: {
        valueSuffix: "%",
        shared: true,
      },
      plotOptions: {
        bar: {
          colorByPoint: true,
          colors: [HC_COLORS.accent],
          negativeColor: "var(--neg)",
          borderWidth: 0,
          borderRadius: 3,
        },
        series: {
          label: { enabled: false },
        },
      },
      legend: { enabled: false },
      xAxis: {
        categories: this.index.data.map((item) => item.company),
        title: { text: null },
        lineColor: "transparent",
        tickColor: "transparent",
        gridLineWidth: 0,
        labels: { style: { color: "var(--text-dim)" } },
      },
      yAxis: {
        labels: { format: "{text}%", style: { color: "var(--text-dim)" } },
        gridLineColor: "var(--border)",
        gridLineDashStyle: "ShortDash",
        gridLineWidth: 1,
        title: {
          text:
            this.chartType.charAt(0).toUpperCase() + this.chartType.slice(1),
          style: {
            color: "var(--text-dim)",
            fontSize: "11px",
            fontWeight: "500",
          },
        },
      },
      series: this.series,
    };
  }
}
